import { AxiosError, AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { Spec } from './spec.types';

export const useGetSpecs = (
    requestBody: { isSubRecipe: boolean, classNo?: number },
    enabled: boolean = true
) => {
  return useQuery<AxiosResponse<Spec[]>>({
    queryKey: ['specs', requestBody.isSubRecipe],
    queryFn: () => apiClient.get<Spec[]>(`/specs`, { params: requestBody }),
    enabled
  });
};

export const useSpecsWithUnusedSubSpecs = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<Spec[]>>({
    queryKey: ['specs-with-unused-sub-specs'],
    queryFn: () => apiClient.get<Spec[]>(`/specs/unused-sub-specs`),
    enabled
  });
};

export const useSpec = (requestBody: { specNo: string, isSubRecipe?: boolean }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<Spec>>({
    queryKey: ['specs', requestBody.specNo, requestBody.isSubRecipe],
    queryFn: () => apiClient.get<Spec>(`/specs/${requestBody.specNo}`, { params: requestBody }),
    enabled,
  });
};

export const useSpecsInRecipe = (
  requestBody: { classNo?: string; baseNo?: string; sizeNo?: string; productNo?: string, statusNo?: string },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Spec[]>>({
    queryKey: ['specs-in-recipe', requestBody.classNo, requestBody.baseNo, requestBody.sizeNo, requestBody.productNo, requestBody.statusNo],
    queryFn: () => apiClient.get<Spec[]>('/specs-in-recipe', { params: requestBody }),
    enabled,
  });
};

export const fetchSpecsInRecipe = async (
  requestBody: { classNo?: string; baseNo?: string; sizeNo?: string; productNo?: string },
  onSuccess?: (response: AxiosResponse) => void,
  onError?: (error: AxiosError) => void
) => {
  try {
    const response = await apiClient.get<Spec[]>('/specs-in-recipe', { params: requestBody });
    onSuccess && onSuccess(response);
  } catch (error) {
    onError && onError(error as AxiosError);
  }
};

export const useSpecsInSubrecipe = (
  requestBody: { classNo?: string; baseNo?: string; sizeNo?: string; productNo?: string; optionNo?: string, statusNo?: string },
  enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Spec[]>>({
    queryKey: [
      'specs-in-subrecipe',
      requestBody.classNo,
      requestBody.baseNo,
      requestBody.sizeNo,
      requestBody.productNo,
      requestBody.optionNo,
      requestBody.statusNo,
    ],
    queryFn: () => apiClient.get<Spec[]>('/specs-in-subrecipe', { params: requestBody }),
    enabled,
  });
};